
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21.9998 12C21.9998 6.52003 17.5998 2.07003 12.1398 2.00003C8.51983 1.95003 5.28983 4.03003 3.42983 7.14003C0.0998343 12.69 2.97983 18.27 7.99983 20.25V20.5C7.99983 21.33 8.66983 22 9.49983 22H14.4998C15.3298 22 15.9998 21.33 15.9998 20.5V20.25C19.5298 18.86 21.9998 15.69 21.9998 12ZM19.9998 12H15.9998V5.08003C18.3898 6.47003 19.9998 9.05003 19.9998 12ZM13.9998 4.26003V12H9.99983V4.26003C10.6398 4.10003 11.3098 4.00003 11.9998 4.00003C12.6898 4.00003 13.3598 4.10003 13.9998 4.26003ZM3.99983 12C3.99983 9.05003 5.60983 6.47003 7.99983 5.08003V12H3.99983Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-rice-bowl`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconRiceBowl

    ```js
    <b-new-b-icon-rice-bowl />
    ```
</docs>


